import { TextVerticalSpacer, theme } from '@superhi/design'
import styled from 'styled-components'
export type Color =
  | 'blue'
  | 'pale-blue'
  | 'warm-blue'
  | 'green'
  | 'pink'
  | 'red'
  | 'yellow'
  | 'grey'

const COLOR: Record<Color, keyof typeof theme.colors> = {
  blue: 'BLUE_30',
  green: 'GREEN_10',
  grey: 'GREY_10',
  'pale-blue': 'PALE_BLUE_40',
  pink: 'PINK_20',
  red: 'PALE_BLUE_70',
  'warm-blue': 'WARM_BLUE_30',
  yellow: 'YELLOW_20',
}

type WrapperProps = {
  $backgroundColor: Color
}

export const Wrapper = styled.div<WrapperProps>`
  padding: 32px 0;

  @media ${theme.breakpoints.medium} {
    padding: 40px 0;
  }

  @media ${theme.breakpoints.large} {
    padding: 64px 0;
  }

  background-color: ${({ $backgroundColor }) => theme.colors[COLOR[$backgroundColor]]};
`

export const Content = styled(TextVerticalSpacer).attrs({ level: '3' })`
  display: flex;
  flex-direction: column;
  align-items: center;
`
